import React from 'react'
import LeaveComponentBar from './LeaveComponentBar'
import TimelineItemSummary from './TimelineItemSummary'
import MilestoneSummary from './MilestoneSummary'
class CalendarDay extends React.Component {

  handleClick () {
    this.props.displaySummary(this.props.data.date)
  }

  activeClass () {
    return (this.props.showSummary ? 'active' : '')
  }

  dateClass () {
    return (this.props.data.requested_month ? 'active-date' : 'inactive-date')
  }


  renderPointer () {
    if (this.props.showSummary){
      return (
        <div className='pointer'></div>
      )
    }
    return null
  }

  renderPaidLeave() {
    return (
      <div className='leave-bar-div paid-leave-bar'>
        { (this.props.show_paid_leave && this.props.data.current_day_paid_leave) ? <LeaveComponentBar next_day_benefit={this.props.data.next_day_paid_leave} />: null }
      </div>
    )
  }

  renderJobProtectedLeave() {
    return (
      <div className='leave-bar-div job-protected-leave-bar'>
        { (this.props.show_job_protected_leave && this.props.data.current_day_job_protected_leave) ? <LeaveComponentBar next_day_benefit={this.props.data.next_day_job_protected_leave} />: null }
      </div>
    )
  }

  renderCalendarDate () {
    return (
      <div className={`calendar-date ${this.dateClass()}`}>{moment(this.props.data.date).format('D')}</div>
    )
  }

  renderDaySummary () {
    return (
      <div className='day-summary'>
        <TimelineItemSummary
          timeline_events={this.props.data.data.timeline_events}
          show_hidden_tasks={this.props.show_hidden_tasks}
        />
        <MilestoneSummary
          milestone_events={this.props.data.data.milestone_events}
        />
      </div>
    )
  }

  render () {
    return (
      <div className={`calendar-day ${this.activeClass()}`} onClick={this.handleClick.bind(this)}>
        { this.renderCalendarDate() }
        { this.renderPaidLeave() }
        { this.renderJobProtectedLeave() }
        { this.renderDaySummary() }
        { this.renderPointer() }
      </div>
    )
  }
}

export default CalendarDay;